import React, { useState, useEffect, memo } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import dayjs from 'dayjs';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import Popups from '../../components/Popup';
import { dateToShortString } from '../../utils/dateFormat';
import { usePopupContext } from '../../contexts/PopupContext';

const PushNextActionPopup = ({ popup }) => {
  const { closePopup, updatePopupFormData } = usePopupContext();
  const [isSubmitting, setSubmitting] = useState(false);
  const idList = popup.getIn(['props', 'idList']);
  const activities = popup.getIn(['props', 'activities']);
  const afterSuccess = popup.getIn(['props', 'afterSuccess']);
  const afterError = popup.getIn(['props', 'afterError']);
  const onUpdate = popup.getIn(['props', 'onUpdate']);
  const formData = popup.get('formData');

  useEffect(() => {
    updatePopupFormData({ date: dayjs().toDate() });
  }, [updatePopupFormData]);

  const handleClose = () => {
    closePopup();
  };

  const handleActivityChange = data => {
    updatePopupFormData({
      activity: data,
    });
  };

  const handleDateChange = ({ target }) => {
    if (target.value.isValid()) {
      updatePopupFormData({
        [target.name]: target.value,
      });
    }
  };

  const isFormValid = () => {
    const date = popup.getIn(['formData', 'date']);
    const error = [];

    if (!date) {
      error.push('Date field is required.');
    }
    updatePopupFormData({ formError: List(error) });

    return error.length === 0;
  };

  const handleUpdate = () => {
    if (isFormValid()) {
      setSubmitting(true);

      const date = popup.getIn(['formData', 'date']);
      const activity = popup.getIn(['formData', 'activity', 'text']);
      const params = {
        selected_ids: idList.toJS(),
        date: dateToShortString(new Date(date)),
        activity,
      };

      onUpdate(
        params,
        () => {
          setSubmitting(false);
          afterSuccess();
        },
        () => {
          setSubmitting(false);
          afterError();
        },
      );
    }
  };

  return (
    <Popups.PushNextActionPopup
      activities={activities}
      formData={formData}
      formError={formData.get('formError')}
      idList={idList}
      isSubmitting={isSubmitting}
      onActivityChange={handleActivityChange}
      onClose={handleClose}
      onDateChange={handleDateChange}
      onUpdate={handleUpdate}
    />
  );
};

function mapStateToProps(state, props) {
  return {
    ...props,
  };
}

export { PushNextActionPopup };
export default connect(mapStateToProps, {}, mergeProps, connectOptions)(memo(PushNextActionPopup));
